import { createFileRoute } from '@tanstack/react-router';
import Register from 'features/Auth/Register/Register.component';

export const Route = createFileRoute('/(auth)/_auth/register')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Register />;
}
